export default __webpack_public_path__ + "img/7757dbce26911a74bece6f864b7e9ff2.png";